// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2Np3A","content":"LayoutSettings_content__1Wncd"};